define.alias("shared/components/shared/expandable-truncated-text", "settings/components/shared/expandable-truncated-text");